import { createFileRoute } from '@tanstack/react-router'

import { TaskListPage } from '@/pages/task-list/TaskList.page'

export const Route = createFileRoute('/_auth/task-list/')({
  component: TaskListPage,
  loader: () => ({ breadcrumbTitle: 'Task List' }),
})
